<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01">
<p class="chapterNumber"><span class="bold">C<span class="smallcaps">HAPTER</span> 1</span></p>
<p class="chapterTitle">Foul Deeds and Murder through the Ages, 1236–1984</p>
<p class="sectionTitle">Tyburn Tree has its First Victims 1236</p>
<p class="extractTextNoIndent"><em class="italic">… he should hang so long as anything should be left whole of him. </em></p>
<p class="paraNoIndent"><span class="dropcap">I</span>n <em class="italic">Tyburn Tree Its History And Annals </em>by Alfred Marks, a fascinating volume which refers to the text of many rare and ancient documents, what is believed to be the first record of Tyburn Tree reads:</p>
<p class="extractTextNoIndent"><span class="bold"><em class="italic">1236 </em></span><em class="italic">About this time some bold but rash nobles in England, seduced by we know not what spirit, conspired together, and entered into an execrable alliance to ravage England like robbers and night-thieves. Their design, however, became known, and the chief of the conspiracy – to wit, Peter de Buffer, one of the king’s doorkeepers – was taken prisoner, and by him others were accused. In order to whose execution a dreadful machine called a gibbet, was set up in London, and on it two of the chief conspirators were hanged, after having engaged in single combat. One of them was killed in the fight, and was hanged with his </em><em class="italic">head cleft open, and the other, hanged alive, breathed forth and his wretched life on the same gibbet amid the lamentations of the assembled multitude. </em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fouldeeds_ch01.vue?eff9757c